module.exports = __webpack_public_path__ + "img/icon-statistical-result.32d8e817.svg";